module.exports = __webpack_public_path__ + "media/images/badge/partita-perfetta-0ecb94e2c42a8b7ae29271cac6aa2f3a.png";